import { Injectable } from '@angular/core';
import axios from 'axios';

import { LoadingController, ToastController } from '@ionic/angular';

import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js'

@Injectable({
  providedIn: 'root'
})
export class StateService {

  Entity: any = [];
  CEO: any = {
    SameCFO: false,
    SameSecretary: false,
    SameDirector: false,
    FirstName: "",
    MiddleName: "",
    LastName: "",
    Address: "",
    ContactAddress: "",
    City: "",
    State: "",
    ZipCode: ""
  };
  CFO: any = {};
  Secretary: any = {};
  Directors: any = [];
  OtherPersons: any = [];
  isOtherPerson: any = false;
  Info: any = {};
  AddedInfo: any = {};
  isColoradoDomain: boolean = false;
  isWyomingDomain: boolean = false;
  // Wyoming only: asset worksheet used to compute the annual report license tax.
  Assets: any = {
    cash: 0,
    tradeNotesAndAccountsReceivable: 0,
    subtractAllowanceForBadDebts: 0,
    inventories: 0,
    USGovernmentObligations: 0,
    taxExemptSecurities: 0,
    otherCurrentAssets: 0,
    loansToStockholders: 0,
    mortgageAndRealEstateLoans: 0,
    otherInvestments: 0,
    depreciableAssets: 0,
    depletableAssets: 0,
    land: 0,
    intangibleAssets: 0,
    subtractAccumulatedAmortization: 0,
    otherAssets: 0,
    totalAssetValueForComputingTax: 0,
  };

  isLoading: any = "";
  loading: any;
  Loading: Boolean = true;

  // URL = "https://w1rytignb1.execute-api.us-west-1.amazonaws.com/dev/";
  URL = "https://efilebusiness-search-backend.vercel.app";
  // URL = "http://localhost:3000";

  constructor(
    public loadingController: LoadingController,
    public toastController: ToastController,
    private storage: Storage,
  ) { }

  // Single source of truth for the Colorado (co.ebizfile.com) flow.
  // Callable from any page so the Colorado-only fields cannot be skipped
  // depending on which page the user landed on first.
  detectColoradoDomain() {
    const urlParams = new URLSearchParams(window.location.search);
    const testColorado = urlParams.get('testColorado');
    const currentHostname = window.location.hostname;

    this.isColoradoDomain = currentHostname === 'co.ebizfile.com' || testColorado === 'true';
    // wy.ebizfile.com -> Wyoming annual report; ?testWyoming=true for local testing.
    this.isWyomingDomain = currentHostname === 'wy.ebizfile.com' || urlParams.get('testWyoming') === 'true';

    return this.isColoradoDomain;
  }

  async decryptObject(data) {
    let getoriginaltext = await data.toString();
    var decrypted = CryptoJS.AES.decrypt(getoriginaltext, '=A[W%Yz<joV*3_Y)')
    data = CryptoJS.enc.Utf8.stringify(decrypted)
    let object = JSON.parse(data)
    return object
  }

  GetData(term) {
    return new Promise(resolve => {
      axios.get(this.URL + "/searchByNumber?term=" + term).then(async (res) => {
        this.Entity = await this.decryptObject(res.data)
        this.Entity.EntityName = this.Entity.EntityName.split("\n").pop();
        console.log("Entity",this.Entity)
        if (this.Entity.CEOfirstName) {
          this.CEO.FirstName = this.Entity.CEOfirstName.trim()
        }
        if (this.Entity.CEOmiddlename) {
          this.CEO.MiddleName = this.Entity.CEOmiddlename.trim()
        }
        if (this.Entity.CEOlastname) {
          this.CEO.LastName = this.Entity.CEOlastname.trim()
        }
        if (this.Entity.CEOAddress || this.Entity.CEOContactAddress) {
          let address = this.Entity.CEOAddress ? this.Entity.CEOAddress.trim() : '';
          let contact = this.Entity.CEOContactAddress ? this.Entity.CEOContactAddress.trim() : '';
          this.CEO.Address = contact ? `${address}, ${contact}` : address;
        }
        if (this.Entity.CEOCity) {
          this.CEO.City = this.Entity.CEOCity.trim();
        }
        if (this.Entity.CEOState) {
          this.CEO.State = this.Entity.CEOState.trim();
        }
        if (this.Entity.CEOZip) {
          this.CEO.ZipCode = this.Entity.CEOZip.trim();
        }
        this.storage.set("entity", this.Entity).then((res) => {
        })
        if (res) {
          this.Loading = false;
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  AddData() {
    return new Promise(resolve => {

      let payload = {
        EntityName: this.Entity.EntityName,
        EntityNumber: this.Entity.EntityNumber,
        Jurisdiction: this.Entity.Jurisdiction,
        RegistrationDate: this.Entity.RegistrationDate,
        Status: this.Entity.Status,
        AgentForServiceOfProcessName: this.Entity.AgentForServiceOfProcessName,
        EntityType: this.Entity.EntityType,
        AgentForServiceOfProcessAddress: this.Entity.AgentForServiceOfProcessAddress,
        AgentIdType: this.Entity.AgentIdType,
        AgentIdNumber: this.Entity.AgentIdNumber,
        EntityAddress: this.Entity.EntityAddress,
        EntityMailingAddress: this.Entity.EntityMailingAddress || this.Entity.EntityAddress,
        Persons: {
          CEO: this.CEO,
          CFO: this.CFO,
          Secretary: this.Secretary,
          Directors: this.Directors,
          OtherPersons: this.OtherPersons
        },
        ...(this.isWyomingDomain ? this.Assets : {})
      }



      axios.post(this.URL + "/data/addinformation", payload).then((res) => {
        if (res) {
          this.AddedInfo = res.data.addinformation;
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      keyboardClose: true,
      position: 'top',
    });
    toast.present();
  }

  async presentLoading(msg) {
    this.isLoading = true;
    this.loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: msg,
    });
    this.loading.present().then((res) => {
      if (!this.isLoading) {
        this.isLoading = false;
        this.loading.dismiss();
      }
    });
  }

  HideLoading() {
    this.isLoading = false;
    this.loading.dismiss();
  }
}
